import React from "react";
import { Navigate } from "react-router-dom";
const ProtectedRoutes = ({ isAuth, redirectPath = "/", children }) => {
  if (!isAuth) {
    return <Navigate to={redirectPath} state={{ showModal: true }} replace />;
  }
  return children;
};
export default ProtectedRoutes;
